import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IsRowSelectable, RowSelectedEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Deletebutton } from 'src/app/shared/common/Deletebutton';
import { DownloadScrapeReport } from 'src/app/shared/common/DownloadScrapeReport';
import { AttachmentButton } from 'src/app/shared/common/attachmentButton';
import { constants } from 'src/app/shared/common/contants';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { DownloadTestResult } from 'src/app/shared/common/testResultDownloadButton';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ScrapingWebPagesService } from 'src/app/shared/services/scraping-web-pages.service';
import { VaultBinderReferenceComponent } from 'src/app/vault-binder-reference/vault-binder-reference.component';
import { WebScrapingPopupComponent } from './web-scraping-popup/web-scraping-popup.component';

@Component({
    selector: 'app-web-scraping',
    templateUrl: './web-scraping.component.html',
    styleUrls: ['./web-scraping.component.scss'],
    standalone: false
})
export class WebScrapingComponent implements OnInit {

  backgroundColorScreen=""
  backgroundColorButton=""
  columnDefs
  historyColumnDefs
  compareHistoryColumnDefs
  defaultColDef
  historyColDef
  compareHistoryColDef
  rowSelection
  historyRowSelection
  compareHistoryRowSelection
  paginationNumberFormatter
  paginationPageSize
  gridApi
  historyGridApi
  compareHistoryGridApi
  grid
  historyGrid
  compareHistoryGrid
  components
  getSelectedRows
  getHistorySelectedRows
  getCompareHistorySelectedRows
  pageSize;
  historyPageSize;
  compareHistoryPageSize
  value;
  historyValue;
  compareHistoryValue
  currentPage;
  historyCurrentPage;
  compareHistoryCurrentPage
  totalPages;
  historyTotalPages;
  compareHistoryTotalPages
  lastPage;
  historyLastPage;
  compareHistoryLastPage
  nextPage;
  historyNextPage
  compareHistoryNextPage
  nextPagePlusOne;
  historyNextPagePlusOne;
  compareHistoryNextPagePlusOne
  rowData;
  historyRowData;
  compareHistoryRowData;
  ReportPath
  isdisable=false;
  gridOptions
  constructor(private localStorageSettings: LocalStorageSettingsService,
    private scrapingService:ScrapingWebPagesService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private loginService: LoginService,
    private constants: constants,
    private service: CommonService,
    private dialog: MatDialog
    ) {

    this.components = {
      attachmentBttn:AttachmentButton,
      downloadbuttonRenderer:FiledownloadComponent,
      delete:Deletebutton,
      vaultReference : VaultBinderReferenceComponent,
      testResult:DownloadScrapeReport,
    }
    
   }

  ngOnInit(): void {
    this.spinner.start()
    this.ScrapingHeaders();
    this.ScrapingHistoryHeaders();
    this.compareHistory();
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.spinner.stop()
  }
  compareHistory(){
    
    this.compareHistoryColumnDefs=[
      {
        headerCheckboxSelection: false,
        checkboxSelection: false,
        headerName: 'S No',
        headerTooltip: 'S No',
        tooltipValueGetter: (params) => 'S No : ' + params.value,
        field: 'compareHistoryId',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Compare Name',
        headerTooltip: 'Compare Name',
        tooltipValueGetter: (params) => 'Compare Name : ' + params.value,
        field: 'compareName',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Compare From',
        headerTooltip: 'Compare From',
        tooltipValueGetter: (params) => 'Compare From : ' + params.value,
        field: 'compareFrom',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Compare To',
        headerTooltip: 'Compare To',
        tooltipValueGetter: (params) => 'Compare To : ' + params.value,
        field: 'compareTo',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Start Date Time',
        headerTooltip: 'Start Date Time',
        tooltipValueGetter: (params) => 'Start Date Time : ' + params.value,
        field: 'startDateTime',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'End Date Time',
        headerTooltip: 'End Date Time',
        tooltipValueGetter: (params) => 'End Date Time : ' + params.value,
        field: 'endDateTime',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Download Report',
        headerTooltip: 'Download Report',
        filter: false, 
        cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.reportDirectoryDownload.bind(this)
          //delete: this.deleteIcon.bind(this),
        },
        width: 150
      },
      {
        headerName: 'Executed By',
        headerTooltip: 'Executed By',
        tooltipValueGetter: (params) => 'Executed By : ' + params.value,
        field: 'executedBy',
        filter: 'agTextColumnFilter',
        width: 250
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 250
      },
      
    ]
   
    this.compareHistoryRowSelection='multiple'
   
    this.compareHistoryColDef={
      // flex: 1,
      sortable: true,
      resizable: true,
      filter: true,
    };
  }
ScrapingHistoryHeaders(){
  this.historyColumnDefs=[
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'status',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Date & Time',
      headerTooltip: 'Date & Time',
      tooltipValueGetter: (params) => 'Date & Time : ' + params.value,
      field: 'dateAndTime',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Selection Type',
      headerTooltip: 'Selection Type',
      tooltipValueGetter: (params) => 'Selection Type : ' + params.value,
      field: 'selectType',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Run By',
      headerTooltip: 'Run By',
      tooltipValueGetter: (params) => 'Run By : ' + params.value,
      field: 'runBy',
      filter: 'agTextColumnFilter',
    },{
      headerName: 'Run Id',
      headerTooltip: 'Run Id',
      tooltipValueGetter: (params) => 'Run Id : ' + params.value,
      field: 'scrapeRunId',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Remarks',
      headerTooltip: 'Remarks',
      tooltipValueGetter: (params) => 'Remarks : ' + params.value,
      field: 'remarks',
      filter: 'agTextColumnFilter',
    },
    
    
  ]
 
  this.historyRowSelection='multiple'
  this.gridOptions = {
    onSelectionChanged: this.onSelectionChanged.bind(this),
  };
  this.historyColDef={
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true,
  };
}
public isRowSelectable(params) {
  if(params.data.status=="Failed" || params.data.status=="In Progress"){
    return false
  }else{
    return true
  }
  // return !!params.data && params.data.year === 2012;
};

onSelectionChanged(e){
this.getHistorySelectedRows=this.historyGridApi.getSelectedRows();
if (this.getHistorySelectedRows.length > 2) {
  // Deselect the last selected row 
  const rowNode = this.historyGridApi.getRowNode(e.api.selectionService.lastSelectedNode.rowIndex);
  rowNode.setSelected(false);
  this.snackBar.open("Please select only two rows.", "OK", { duration: 5000 });
}
}
 ScrapingHeaders(){
  this.columnDefs= [
    {
      headerCheckboxSelection: false,
      checkboxSelection: true,
      headerName: 'DNS Name',
      headerTooltip: 'DNS Name',
      tooltipValueGetter: (params) => 'DNS Name : ' + params.value,
      field: 'pageName',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Vault Version',
      headerTooltip: 'Vault Version',
      tooltipValueGetter: (params) => 'Vault Version : ' + params.value,
      field: 'url',
      filter: 'agTextColumnFilter',
    },

  ]
  this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true,
  };
  this.rowSelection='single'
 }
 async onCompareHistoryGridReady(params){
  this.compareHistoryGrid=params
  this.compareHistoryGridApi=params.api
  this.scrapingService.retreiveCompareHistoryData().subscribe(res=>{
    if(res.error==true){
      // this.spinner.stop();
      this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
    }else{
      this.compareHistoryRowData= res;
      this.compareHistoryGridApi.setGridOption('rowData', this.compareHistoryRowData)
    }
  })
}
  async onHistoryGridReady(params){
    this.historyGrid=params
    this.historyGridApi=params.api
    this.scrapingService.retreiveScrapingHistoryData().subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.historyRowData=res
        console.log(this.historyRowData);
        
        for(let i=0;i<this.historyRowData.length;i++){
          // 
          if(this.historyRowData[i].params != null && this.historyRowData[i].params.length > 0){
            this.historyRowData[i].params=JSON.parse(this.historyRowData[i].params)
          this.historyRowData[i]["selectType"]=""
          this.historyRowData[i]["selectedTypes"]=[]
          console.log(this.historyRowData[i]);
          console.log(this.historyRowData[i].params.Params.AER != null);
          
          if(this.historyRowData[i].params.Params.AER != null){
            this.historyRowData[i].selectedTypes.push("AER")
            if(Array.isArray(this.historyRowData[i].params.Params.AER)){
              if(this.historyRowData[i].params.Params.AER.length > 0){
                for(let j=0;j<this.historyRowData[i].params.Params.AER.length;j++){
                  if(this.historyRowData[i].selectType.length > 0){
                    this.historyRowData[i].selectType=this.historyRowData[i].selectType+", AER: "+this.historyRowData[i].params.Params.AER[j].ObjectName
                  }else{
                    this.historyRowData[i].selectType="AER: "+this.historyRowData[i].params.Params.AER[j].ObjectName
                  }
                }
              }
            }else{
              if(this.historyRowData[i].selectType.length > 0){
                this.historyRowData[i].selectType=this.historyRowData[i].selectType+", AER: "+this.historyRowData[i].params.Params.AER.ObjectName
              }else{
                this.historyRowData[i].selectType="AER: "+this.historyRowData[i].params.Params.AER.ObjectName
              }
            }
            
          }
          if(this.historyRowData[i].params.Params.Case != null){
            this.historyRowData[i].selectedTypes.push("Case")
            if(Array.isArray(this.historyRowData[i].params.Params.Case)){
              if(this.historyRowData[i].params.Params.Case.length > 0){
                for(let j=0;j<this.historyRowData[i].params.Params.Case.length;j++){
                  if(this.historyRowData[i].selectType.length > 0){
                    this.historyRowData[i].selectType=this.historyRowData[i].selectType+", Case: "+this.historyRowData[i].params.Params.Case[j].ObjectName
                  }else{
                    this.historyRowData[i].selectType="Case: "+this.historyRowData[i].params.Params.Case[j].ObjectName
                  }
                }
            }
          }else{
            if(this.historyRowData[i].selectType.length > 0){
              this.historyRowData[i].selectType=this.historyRowData[i].selectType+", Case: "+this.historyRowData[i].params.Params.Case.ObjectName
            }else{
              this.historyRowData[i].selectType="Case: "+this.historyRowData[i].params.Params.Case.ObjectName
            }
          }
          }
          if(this.historyRowData[i].params.Params.Document != null){
            this.historyRowData[i].selectedTypes.push("Document")
            if(Array.isArray(this.historyRowData[i].params.Params.Document)){
              if(this.historyRowData[i].params.Params.Document.length > 0){
                for(let j=0;j<this.historyRowData[i].params.Params.Document.length;j++){
                  if(this.historyRowData[i].selectType.length > 0){
                    this.historyRowData[i].selectType=this.historyRowData[i].selectType+", Document: "+this.historyRowData[i].params.Params.Document[j].ObjectName
                  }else{
                    this.historyRowData[i].selectType="Document: "+this.historyRowData[i].params.Params.Document[j].ObjectName
                  }
                }
              }
            }else{
              if(this.historyRowData[i].selectType.length > 0){
                this.historyRowData[i].selectType=this.historyRowData[i].selectType+", Document: "+this.historyRowData[i].params.Params.Document.ObjectName
              }else{
                this.historyRowData[i].selectType="Document: "+this.historyRowData[i].params.Params.Document.ObjectName
              }
            }
          }
        }
      }
        console.log(this.historyRowData);
        this.historyGridApi.setGridOption('rowData', this.historyRowData)
      }
    })
  }
  async onGridReady(params) {
    console.log(params)
    console.log("service")
    let res: any
    this.grid = params;
    this.gridApi = params.api;
    this.scrapingService.retreiveScrapingWebPagesData().subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.rowData= res
        console.log(this.rowData);
        this.gridApi.setGridOption('rowData', this.rowData)
      }
    })
   
  }
  onExtractClicked(){
    this.getSelectedRows = this.gridApi.getSelectedRows();
    console.log(this.getSelectedRows);
    if(this.getSelectedRows.length > 0){
      let selectedExtractionRows=[]

      var decrypted = this.localStorageSettings.getSettings("EncrptPassword");
      console.log(decrypted);
      
      //console.log(password)
      let extractionObject={
        "dnsId" : this.localStorageSettings.getSettings("dnsName"),
        "url" : this.getSelectedRows[0].url,
        "userName" : this.localStorageSettings.getSettings("AuthUsername"),
        "password" : decrypted,
        "runId" : this.getSelectedRows[0].pageId
    }
    console.log(extractionObject);
    this.spinner.start();
      this.scrapingService.scrapeSelectedWebPage(extractionObject).subscribe(res=>{
        this.spinner.stop();
        console.log(res);
        this.getScrapingHistory()
        this.snackBar.open("Content Extraction Started", "OK", { duration: 5000 });
      })
    }else{
      this.snackBar.open("Please select the page to Extract", "OK", { duration: 5000 });
    }
  }
  onExtractAllClicked(){
    // scrapeSelectedWebPage
  }
  onCompareClick(){
    this.getHistorySelectedRows=this.historyGridApi.getSelectedRows();
    console.log(this.getHistorySelectedRows);
    // this.spinner.start();
    if(this.getHistorySelectedRows.length > 0 ){
      if(this.getHistorySelectedRows.length == 2){
      console.log(this.getHistorySelectedRows);
//       const areArraysEqual = JSON.stringify(this.getHistorySelectedRows[0].selectedTypes) === JSON.stringify(this.getHistorySelectedRows[1].selectedTypes);

// console.log(areArraysEqual); 
//     if(areArraysEqual){
      let pageId1=this.getHistorySelectedRows[0].scrapeRunId
      let pageId2=this.getHistorySelectedRows[1].scrapeRunId
      this.scrapingService.CompareSelectedScrapingHistory(pageId1,pageId2, this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
        this.spinner.stop();
        console.log(res);
        this.getCompareHistory()
        this.snackBar.open("Content Compare Started", "OK", { duration: 5000 });
      })
    // }else{
    //   this.snackBar.open("Selection type should be same to Compare", "OK", { duration: 5000 });
    // }
      
        
  }else{
    this.snackBar.open("Please select two pages to Compare", "OK", { duration: 5000 });
  }
    }else{
      this.snackBar.open("Please select the pages to Compare", "OK", { duration: 5000 });
    }
  }
  onGridReadyForTools(params){
    console.log(params)
    console.log("service")
  }
  onSearchChange(searchValue: number) {

    this.gridApi.paginationGoToPage(searchValue - 1);

  }
  onHistorySearchChange(searchValue: number) {
    this.historyGridApi.paginationGoToPage(searchValue - 1);
  }
  onCompareHistorySearchChange(searchValue: number) {
    this.compareHistoryGridApi.paginationGoToPage(searchValue - 1);
  }
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridApi.setGridOption('paginationPageSize', Number(value));

  }
  onHistoryPageSizeChanged(newPageSize) {
    var value = this.historyPageSize;
    this.historyGridApi.setGridOption('paginationPageSize', Number(value));
  }
  onCompareHistoryPageSizeChanged(newPageSize) {
    var value = this.historyPageSize;
    this.compareHistoryGridApi.setGridOption('paginationPageSize', Number(value));
  }
  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }
  onHistoryBtFirst() {
    this.historyGridApi.paginationGoToFirstPage();
  }
  onCompareHistoryBtFirst() {
    this.compareHistoryGridApi.paginationGoToFirstPage();
  }
  
  // below function for going to last page
  onBtLast() {
    this.gridApi.paginationGoToLastPage();
  }
  onHistoryBtLast() {
    this.historyGridApi.paginationGoToLastPage();
  }
  onCompareHistoryBtLast() {
    this.compareHistoryGridApi.paginationGoToLastPage();
  }
  
  async onBtNext() {
    this.gridApi.paginationGoToNextPage();
  }
  async onHistoryBtNext() {
    this.historyGridApi.paginationGoToNextPage();
  }
  async onCompareHistoryBtNext() {
    this.compareHistoryGridApi.paginationGoToNextPage();
  }
  
  async onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage();
  }
  async onHistoryBtPrevious() {
    this.historyGridApi.paginationGoToPreviousPage();
  }
  async onCompareHistoryBtPrevious() {
    this.compareHistoryGridApi.paginationGoToPreviousPage();
  }
  onPaginationChanged() {

    if (this.gridApi) {

      this.lastPage = this.gridApi.paginationIsLastPageFound();

      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridApi.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridApi.paginationGetTotalPages();

    }

  }
  onHistoryPaginationChanged() {

    if (this.historyGridApi) {

      this.historyLastPage = this.historyGridApi.paginationIsLastPageFound();

      this.historyCurrentPage = this.historyGridApi.paginationGetCurrentPage() + 1;

      this.historyNextPage = this.historyGridApi.paginationGetCurrentPage() + 1 + 1;

      this.historyNextPagePlusOne = this.historyGridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.historyTotalPages = this.historyGridApi.paginationGetTotalPages();

    }
  }
  onCompareHistoryPaginationChanged() {

    if (this.compareHistoryGridApi) {

      this.compareHistoryLastPage = this.compareHistoryGridApi.paginationIsLastPageFound();

      this.compareHistoryCurrentPage = this.compareHistoryGridApi.paginationGetCurrentPage() + 1;

      this.compareHistoryNextPage = this.compareHistoryGridApi.paginationGetCurrentPage() + 1 + 1;

      this.compareHistoryNextPagePlusOne = this.compareHistoryGridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.compareHistoryTotalPages = this.compareHistoryGridApi.paginationGetTotalPages();

    }
  }

  async getScrapingWebPages(){
    console.log(this.rowData);
    this.scrapingService.retreiveScrapingWebPagesData().subscribe(res=>{
      if(res.error==true){
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.rowData= res
      }
    })
  }

  async getScrapingHistory(){
    this.spinner.start();
    console.log(this.historyRowData);
    this.scrapingService.retreiveScrapingHistoryData().subscribe(res=>{
      if(res.error==true){
        this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.spinner.stop();
        this.historyRowData=res
        this.historyGridApi.setGridOption('rowData', this.historyRowData)
      }
    })
  }
  async getCompareHistory(){
 
  this.scrapingService.retreiveCompareHistoryData().subscribe(res=>{
    if(res.error==true){
      this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
    }else{
      this.compareHistoryRowData= res;
      this.compareHistoryGridApi.setGridOption('rowData', this.compareHistoryRowData)
    }
  })
  }

  ReportDownload(e){
    console.log(e.rowData)
    this.ReportPath = e.rowData.scrapeReport
    if(this.ReportPath===undefined || this.ReportPath=== "" || this.ReportPath ===null){
      this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.ReportPath.split('/').pop()
      let data = {
        s3Path:this.ReportPath,
      };
      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }
  testResultPath
  testResult(e){
    console.log(e.rowData)
    this.testResultPath = e.rowData.scrapeReport
    if(this.testResultPath===undefined || this.testResultPath=== "" || this.testResultPath ===null){
      this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.testResultPath.split('/').pop()
      let data = {
        s3Path:this.testResultPath,
      };
      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }
  onHistoryRowSelected(e){
    console.log(e);
    
  }
  reportDirectoryDownload(e){
    console.log(e);
    this.spinner.start();
    if(e.rowData.report ===undefined || e.rowData.report === "" || e.rowData.report  ===null){
      this.spinner.stop();
      this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});
      
    }else{
      console.log(e);
      let downloadObject={
        "inputFileLocalPath" : "comparison_"+e.rowData.compareFrom+"_"+e.rowData.compareTo,
        "inputS3Bucket" : e.rowData.report,
        "inputS3FilePath" : e.rowData.report,
        "dnsId" : 0,
    }
      this.scrapingService.downloadCompareDirectory(downloadObject).subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
     var newBlob = new Blob([x],{type:'application/zip'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = "comparison_"+e.rowData.compareFrom+"_"+e.rowData.compareTo+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.spinner.stop();
    });
    
    }
  }


  testReportResult(e){
    console.log(e.rowData)
    this.testResultPath = e.rowData.report
    if(this.testResultPath===undefined || this.testResultPath=== "" || this.testResultPath ===null){
      this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.testResultPath.split('/').pop()
      let data = {
        s3Path:this.testResultPath,
      };
      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackBar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }
      })

      this.spinner.stop();
    }

  }

  openSaveForm(s){
    console.log(s);
    let dialogRef = this.dialog.open(WebScrapingPopupComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "55%",
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

    });
  }
}